import * as types from "./mutation-types";
import * as authTypes from "../authentication/mutation-types";
import usersService from "../../services/users";
import { createServiceCall } from "../actionsUtil";

export const switchFacility = createServiceCall({
  mainAction: types.SWITCH_FACILITY_REQUEST,
  serviceFunction: usersService.switchFacility,
  successAction: authTypes.LOGIN_SUCCESS,
  successDataProperty: "userobject",
  successCallback: res => {
    if (res && res.userobject) return location.reload();
  },
  failureAction: types.SWITCH_FACILITY_FAILURE
});
